const anchorWallet = localStorage.getItem('anchor-link-.alaktika-list')
const waxWallet = localStorage.getItem('ual-wax:autologin')

export const clearLocal = () => {
  if (anchorWallet) {
    localStorage.removeItem('ual-wax:autologin')
    return {
      wallet: 'Anchor',
      accountName: JSON.parse(anchorWallet)[0].auth.actor,
      userAccount: JSON.parse(anchorWallet),
    }
  }

  if (waxWallet) {
    localStorage.removeItem('anchor-link-.alaktika-list')
    return {
      wallet: 'Wax',
      accountName: JSON.parse(waxWallet).userAccount,
      userAccount: JSON.parse(waxWallet),
    }
  }

  return { wallet: undefined, walletName: undefined, userAccount: null }
} // Trying to persist user data so you don't have to relogin (pseudo-autologin)
